import { type ComponentProps, memo, type RefObject } from 'react';

import { UploadIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

import { UploadZoneOverlay } from '~/components/PrivateDropzone/components/UploadZoneOverlay';
import { type DropZone } from '~/components/PrivateDropzone/types';

/** `ref` is omitted because the zone keeps the one it hit-tests against (`dropZoneChooseBoardRef`). */
export type SingleZoneOverlayProps = Omit<ComponentProps<'div'>, 'ref'> & {
  hoveredZone: DropZone | null;
  currentWorkspaceName?: string;
  dropZoneChooseBoardRef: RefObject<HTMLDivElement>;
};

export const SingleZoneOverlay = memo(
  ({ hoveredZone, currentWorkspaceName, dropZoneChooseBoardRef, className, ...rest }: SingleZoneOverlayProps) => (
    <UploadZoneOverlay
      {...rest}
      className={cn('absolute top-18 right-2 bottom-2 left-2 px-4 py-8 ads:text-primary text-gray-12', className)}
      data-testid="SINGLE_ZONE_OVERLAY_CONTENT"
      description={`Choose where to upload your files in ${currentWorkspaceName || 'this workspace'}`}
      icon={UploadIcon}
      isActive={hoveredZone === 'choose-board'}
      title="Drop files here to upload"
      zoneRef={dropZoneChooseBoardRef}
    />
  ),
);

SingleZoneOverlay.displayName = 'SingleZoneOverlay';
